export const lightTheme = {
  colors: {
    primary: '#000000',
    secondary: '#FFFFFF',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF',
      muted: '#FFFFFF',
      shadow: 'rgba(0, 0, 0, 0.15)'
    },
    background: {
      primary: '#FFFFFF',
      secondary: '#F5F5F5',
      overlay: 'rgba(0, 0, 0, 0.8)'
    },
    button: {
      primary: '#FFFFFF',
      text: '#000000'
    }
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    hero: {
      title: {
        fontSize: '120px',
        lineHeight: '0.9',
        fontWeight: '700',
        letterSpacing: '-0.03em',
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)',
        marginTop: '200px',
        marginBottom: '32px'
      },
      separator: {
        width: '96px',
        height: '2px',
        marginTop: '37px',
        marginBottom: '35px'
      },
      subtitle: {
        fontSize: '24px',
        lineHeight: '1.4',
        fontWeight: '400',
        marginBottom: '50px',
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)'
      },
      cta: {
        fontSize: '18px',
        fontWeight: '500',
        padding: '12px 24px'
      }
    }
  },
  spacing: {
    container: {
      padding: '24px'
    },
    section: {
      padding: '48px 0'
    },
    immersiveWorker: {
      desktop: {
        containerPadding: '16px',
        contentPadding: '16px',
        gap: '16px'
      },
      mobile: {
        containerPadding: '16px 0',
        contentPadding: '40px',
        gap: '20px',
        negativeMargin: '24px'
      }
    },
    immersiveDetail: {
      mobile: {
        cardHeight: '350px',
        imageTopPosition: '20%',
        featuresGap: '12px',
        subtextToFeaturesGap: '-50px',
        contentPadding: '8px',
        closeButton: {
          top: '38px',
          right: '38px'
        }
      },
      narrow: {
        cardHeight: '350px',
        imageTopPosition: '20%',
        featuresGap: '12px',
        subtextToFeaturesGap: '-50px',
        contentPadding: '8px',
        closeButton: {
          top: '38px',
          right: '38px'
        }
      }
    }
  }
};

export const darkTheme = {
  ...lightTheme,
  colors: {
    primary: '#FFFFFF',
    secondary: '#000000',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF',
      muted: '#FFFFFF',
      shadow: 'rgba(0, 0, 0, 0.15)'
    },
    background: {
      primary: '#000000',
      secondary: '#1A1A1A',
      overlay: 'rgba(0, 0, 0, 0.8)'
    },
    button: {
      primary: '#000000',
      text: '#FFFFFF'
    }
  }
}; 